module.exports = __webpack_public_path__ + "img/answer.01806a94.svg";